import { useContext } from 'react';
import { ReasonContext } from './components/Context';
import { ReasonContextState } from './types';

export const useReason = (): ReasonContextState => {
  const context = useContext(ReasonContext);

  if (context === undefined) {
    throw Error(
      'ReasonContext must be used inside ReasonContext Provider scope'
    );
  }

  return context;
};
